// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__19cBe","inputWrap":"CustomTip_inputWrap__1ldNZ"};